import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'
import { CASH_DRAWER_STATUS_UNAVAILABLE_MESSAGE } from '@/lib/services/cash-drawers/cash-drawers.preflight'

export function CashDrawerStatusError({
  isRetrying = false,
  onRetry,
}: {
  isRetrying?: boolean
  onRetry: () => unknown
}) {
  return (
    <div className="space-y-2" role="alert">
      <Typography variant="label" tone="destructive" className="block">
        {CASH_DRAWER_STATUS_UNAVAILABLE_MESSAGE}
      </Typography>
      <Button type="button" variant="outline" size="sm" disabled={isRetrying} onClick={onRetry}>
        {isRetrying ? 'Checking cash drawer…' : 'Try again'}
      </Button>
    </div>
  )
}
